import React from 'react';
import hikingImage from "../../../../theme/img/bg/marcheurs.jpeg";
import ImageBackground from "../../../booking/components/ImageBackground";

const SubmitConfirmationLeftColumn = () => <ImageBackground image={hikingImage} />;

export default SubmitConfirmationLeftColumn;
